export var AnalyticsActions;
(function (AnalyticsActions) {
    AnalyticsActions["GET_ANALYTICS"] = "ANALYTICS/GET_ANALYTICS";
    AnalyticsActions["GET_ANALYTICS_HEADER"] = "ANALYTICS/GET_ANALYTICS_HEADER";
    AnalyticsActions["SET_ANALYTICS_FILTER"] = "ANALYTICS/SET_FILTER";
    AnalyticsActions["SET_ANALYTICS_DATE_PERIOD"] = "ANALYTICS/SET_DATE_PERIOD";
})(AnalyticsActions || (AnalyticsActions = {}));
